const naText = gettext("Not Available");
const notAvailableText = gettext("Subscription is not available at this time");
const NaPackageButton = (props) => {
    let expiryDate = "";
    if(props.productPackage && props.productPackage.hasOwnProperty("expiration_date")){
        expiryDate = props.productPackage.expiration_date;
    } else if(props.productPackage && props.productPackage.hasOwnProperty("exp_date")){
        expiryDate = props.productPackage.exp_date;
    }

    return <React.Fragment>
        <button className="anp-button is-primary full-width" onClick={() => showModalNaSubs(expiryDate)}>{naText}</button>
        <div className="message-text-info">{notAvailableText}</div>
    </React.Fragment>
}

export default NaPackageButton;
